export default function passwordValidation(_, value) {
  if (value === '' || value === undefined || value.length >= 8)
    return Promise.resolve();
  return Promise.reject(new Error('Password min length 8'));
}
